export default "__VITE_ASSET__326adc86__"